import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  FormControl,
  Card,
  CardContent
} from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import SettingsIcon from '@mui/icons-material/Settings'
import CloudIcon from '@mui/icons-material/Cloud'
import { EMAIL_ACCOUNT_TYPES } from '../../../utils/campaignConstants'

const AccountTypeSelector = ({ accountType, originalAccountType, onChange }) => {
  const { t } = useTranslation()

  const accountTypeOptions = [
    {
      value: EMAIL_ACCOUNT_TYPES.USERNAME_PASSWORD,
      icon: <SettingsIcon sx={{ color: 'primary.main' }}/>,
      title: t('mailTemplate.users.modal.manualConfiguration'),
      description: t('mailTemplate.users.modal.manualDescription')
    },
    {
      value: EMAIL_ACCOUNT_TYPES.GMAIL_OAUTH2,
      icon: <EmailIcon sx={{ color: 'primary.main' }}/>,
      title: t('mailTemplate.users.modal.connectWithGmail'),
      description: t('mailTemplate.users.modal.gmailDescription')
    },
    {
      value: EMAIL_ACCOUNT_TYPES.EXTERNAL_SERVICE,
      icon: <CloudIcon sx={{ color: 'primary.main' }}/>,
      title: t('mailTemplate.users.modal.externalService'),
      description: t('mailTemplate.users.modal.externalServiceDescription')
    }
  ]

  return (
    <Box sx={{ mb: 4 }}>
      <FormControl component="fieldset" sx={{ width: '100%' }}>
        <RadioGroup
          value={accountType}
          onChange={onChange}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 2
          }}
        >
          {accountTypeOptions.map((option) => (
            <Card
              key={option.value}
              variant="outlined"
              sx={{
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 3,
                flex: { xs: '1 1 100%', lg: '1 1 0' },
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.02)'
                }
              }}
              onClick={() => onChange({ target: { value: option.value } })}
            >
              <CardContent sx={{ py: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                  <Radio
                    checked={accountType === option.value}
                    onChange={onChange}
                    value={option.value}
                  />
                  {option.icon}
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.9rem' }}>
                      {option.title}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.primary', opacity: 0.7, mt: 0.2, display: 'block' }}>
                      {option.description}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

export default AccountTypeSelector
